import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { FormState } from './types';
import { RootState } from './../types';

export const state: FormState = {
    location: {
        href: '',
        routerLink: 'start',
        oldUrl: ''
    },
    isVisibleForm: true,
    isResettingForm: false,
    wasClickedOnShowResultButton: false,
    showResultPage: false,
    isValid: false,
    isTouched: false,
    hasDefaultValues: false,
    urls: {
        expertPartnerUrl: '/sachverstaendige/'
    },
    labels: {},
    icons: {},
    images: {},
    settings: {},
    steps: {
        1: ['isCar', 'useHsnTsn', 'vehicle', 'fieldHSN', 'fieldTSN'],
        2: ['firstRegistration', 'mileage'],
        3: ['fieldModel', 'fieldStructureType', 'fieldDoors', 'fieldFuel'],
        4: ['fieldModelType', 'fieldSubType', 'fieldEngine', 'fieldGearType', 'fieldDriveType', 'vehicleSelected'],
        5: ['fieldLocation', 'fieldEmail']
    },
    inputs: {
        isCar: {
            value: 'value',
            valid: false,
            reset: false,
            isAutoSelected: false,
            validation: ['car', 'motorcycle'],
            order: 1,
            step: 1
        },
        useHsnTsn: {
            value: false,
            valid: false,
            reset: false,
            isAutoSelected: false,
            validation: ['car', 'motorcycle'],
            order: 2,
            step: 1
        },
        vehicle: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            apiFilterName: 'manufacturer',
            validation: ['car', 'motorcycle'],
            order: 3,
            step: 1
        },
        firstRegistration: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            validation: ['car', 'motorcycle'],
            order: 4,
            step: 2
        },
        mileage: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            validation: ['car', 'motorcycle'],
            order: 5,
            step: 2
        },
        fieldModel: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            apiFilterName: 'mainTypeGroupFb',
            validation: ['car'],
            order: 6,
            step: 3
        },
        fieldModelType: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            apiFilterName: 'mainTypeFb',
            apiMotorCycleFilterName: 'mainTypeForMotorcycles',
            validation: ['car', 'motorcycle'],
            order: 13,
            step: 4
        },
        fieldSubType: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            apiFilterName: 'subType',
            apiMotorCycleFilterName: 'subTypeForMotorcycles',
            validation: ['car', 'motorcycle'],
            order: 14,
            step: 4
        },
        fieldStructureType: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            apiFilterName: 'structureType',
            validation: ['car'],
            order: 7,
            step: 3
        },
        fieldDoors: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            apiFilterName: 'countOfDoors',
            validation: ['car'],
            order: 8,
            step: 3
        },
        fieldEngine: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            apiFilterName: 'engine',
            validation: ['car', 'motorcycle'],
            order: 10,
            step: 4
        },
        fieldFuel: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            apiFilterName: 'fuelMethod',
            validation: ['car'],
            order: 9,
            step: 3
        },
        fieldGearType: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            apiFilterName: 'gearType',
            validation: ['car'],
            order: 12,
            step: 4
        },
        fieldDriveType: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            apiFilterName: 'driveType',
            validation: ['car'],
            order: 11,
            step: 4
        },
        vehicleSelected: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            apiFilterName: 'vehicleSelected',
            validation: ['car', 'motorcycle'],
            order: 15,
            step: 4
        },
        fieldHSN: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            order: 2,
            step: 1
        },
        fieldTSN: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            order: 2,
            step: 1
        },
        fieldLocation: {
            value: '',
            valid: false,
            reset: false,
            isAutoSelected: false,
            validation: ['car', 'motorcycle'],
            order: 18,
            step: 5
        },
        fieldEmail: {
            value: '',
            valid: false,
            reset: false,
            checked: false,
            isAutoSelected: false,
            validation: ['car', 'motorcycle'],
            order: 19,
            step: 5
        },
    },
    data: {
        hsnTsnService: {
            'fieldHSN': '',
            'fieldTSN': '',
            'datECodes': '',
        },
        allowedVehicleTypes: {
            value: [],
        },
        filter: {
            value: {},
        },
        filters: {
            value: {},
        },
        identificationByKba: {
            value: false,
        },
        datECodes: {
            value: [],
        },
        carCount: {
            value: 0,
        },
        carCountHsnTsn: {
            value: 0,
        },
        selectedCar: {
            value: {},
        },
        vehicleSelection: {
            value: {},
        },
        selectedManufacturer: {
            value: '',
        },
        carThresholdCount: {
            value: 15
        },
        predefinedManufacturerValues: {
            hasValue: false,
            mileage: '',
            firstRegistration: '',
            manufacturerValue: {
                brand: '',
                vehicle: '',
                vehicleType: true
            }
        },
        frequentItems: {
            'car': ['905', '570', '650', '285', '130', '60'],
            'motorcycle': ['130', '320', '340', '420', '455', '950']
        },
        cache: {
            images: {}
        },
        valuateServiceResult: {
            value: {}
        },
        hasContentElements: {
            value: false
        },
        hiddenContentQuerySelector: {
            value: ''
        },
        currentStep: {
            value: 1
        },
       availableSteps: {
            value: [1]
        },
    },
    funnelStep: {
        properties: {
            stepProcessed: '',
            stepProcessedNum: '',
            funnelName: 'Gebrauchtfahrzeugwerte',
            funnelCategory: 'B2C',
            stepURL: '',
            referrerURL: '',
            zipCode: '',
            initialRegistrationYear: '',
            initialRegistrationMonth: '',
            mileage: '',
            certificateAvailable: '',
            carType: '',
            manufacturer: '',
            carModel: '',
            carModelType: '',
            numberOfDoors: '',
            fuelType: '',
            power: '',
            engine: '',
            driveType: '',
            transmissionType: '',
            transmissionModel: '',
            carModel_precise: '',
            carModelVersion: '',
            constructionYearFrom: '',
            constructionYearTo: '',
            estimatedCarValue: '',
            certificateAvailableHsn: '',
            certificateAvailableTsn: '',
        }
    },
    funnelStepExtraData: {}
};

const namespaced: boolean = true;

export const form: Module<FormState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
